<template>
    <div>
        <div :class="{sticky: sticky}">
            <div class="slotHeader" style="height: 35px;">
                <div v-if="showMoveIcons" class="move">
                    <span @click="moveUp" class="icon icon-sort-up"></span>
                    <span @click="moveDown" class="icon icon-sort-down"></span>
                </div>
                <div class="wrapper">
                    <InputDetail v-if="showActions && (titleEditable && editAllowed)" :background="'none'"
                                 :border="'none'" :value="this.name"
                                 font-size="15px" class="title" :autoWidth="true"
                                 @input="nameChanged($event)"></InputDetail>
                    <div v-if="!showActions || !editAllowed" class="module title" :class="{noEdit: !editAllowed}">
                        {{this.name}}
                    </div>
                </div>
                <div v-if="showActions && editAllowed" @click="$emit('add')" class="icon actionIcon">
                    <span class="icon-add"></span>
                </div>
                <div v-if="showActions && editAllowed" @click="$emit('duplicate')" class="icon actionIcon">
                    <span class="icon-duplicate"></span>
                </div>
                <div v-if="showActions && editAllowed" @click="$emit('delete')" class="icon actionIcon">
                    <span class="icon-delete"></span>
                </div>
            </div>
        </div>
        <div class="content">
            <slot></slot>
        </div>
    </div>
</template>

<script>
    import InputDetail from "../../components/inputs/InputDetail";

    export default {
        name: "ModuleSection",
        components: {
            InputDetail
        },
        props: {
            title: String,
            spaceId: Number,
            moduleId: Number,
            sticky: {
                type: Boolean,
                default: false
            },
            showActions: {
                type: Boolean,
                default: true
            },
            showMoveIcons: {
                type: Boolean,
                default: true
            },
            titleEditable: {
                type: Boolean,
                default: false
            },
            space: {
                type: Object
            }
        },
        computed: {
            name: {
                get() {
                    let name;
                    if (this.$store.state.trackingList.dashboard.cache.length !== 0) {
                        let trackingListID = this.$store.state.trackingList.dashboard.tracking_list_id;
                        let cache = this.$store.state.trackingList.dashboard.cache;
                        let trackingList = cache.find(x => x.id === trackingListID);
                        name = trackingList.spaces[this.spaceId].modules[this.moduleId]['name']
                    } else {
                        if(this.$route.name === 'showReporting'){
                            name = this.space.modules[this.moduleId]['name'];
                        } else{
                            name = this.$store.state.trackingList.data.spaces[this.spaceId].modules[this.moduleId]['name'];
                        }

                    }
                    return name;
                },
                set(value) {
                    this.$store.commit('trackingList/setModuleName', {
                        moduleIndex: this.moduleId,
                        spaceIndex: this.spaceId,
                        name: value
                    });
                }
            },
            editAllowed() {
                let status = this.$store.state.trackingList.data.status;
                if (typeof status !== "undefined") {
                    if (status.indexOf('eingebaut') !== -1) {
                        //status is pink
                        if (Object.prototype.hasOwnProperty.call(this.space, 'initial') && this.space.initial) {
                            //initial space
                            return false;
                        }
                    }
                }
                return true;
            }
        },
        methods: {
            moveUp() {
                this.$store.commit('trackingList/moveModuleUp', {
                    spaceId: this.spaceId,
                    moduleId: this.moduleId
                });
            },
            moveDown() {
                this.$store.commit('trackingList/moveModuleDown', {
                    spaceId: this.spaceId,
                    moduleId: this.moduleId
                });
            },
            nameChanged(newName) {
                this.name = newName;
            }
        }
    }
</script>

<style lang="scss" scoped>
    .wrapper {
        display: inline-block;
        min-width: 185px;
        padding-left: 20px;
        margin-left: 10px;
        margin-top: 3px;

        ::v-deep input {
            padding: 5px;
        }
    }


    .slotHeader {
        display: flex;
        align-items: center;
        background: white;
        height: 40px;
        width: 100%;
        font-weight: 500;
        font-size: inherit;
        -moz-user-select: none;
        -webkit-user-select: none;
        -ms-user-select: none;
        user-select: none;
        -o-user-select: none;
        position: relative;
    }

    .title {
        font-weight: 400;
    }

    /*.slotHeader > div:first-child {
        padding: 0 1.3em;
        min-width: 13rem;
    }*/

    .icon-add {
        color: #d70364;
    }

    .icon {
        cursor: pointer;
    }

    .actionIcon {
        display: inline-block;
        padding: 0.7em 0.7em 0.3em 0.7em;
        cursor: pointer;
    }

    .actionIcon span {
        font-size: 1.3em;
    }

    @media screen and (min-width: 1025px) {
        .sticky {
            width: 100%;
            background: #fff;

            .slotHeader {
                width: fit-content;
                position: sticky;
                left: 0;
            }
        }
    }

    .move {
        position: absolute;
        top: 0;
        left: 10px;
        display: flex;
        flex-flow: column;
        height: 36px;
        justify-content: space-between;
        font-size: 12px !important;
        color: $grey;
        padding: 4px 3px 1px 3px;
        margin-top: 2px;
        cursor: pointer;
    }

</style>
